import { number, object, string } from 'yup';

export const actionBasedFormValidationSchema = object().shape({
  pluginMetadata: object().shape({
    action: string()
      .required('Action name is required')
      .matches(
        /^[a-zA-Z0-9_]+$/,
        'Action name can only contain alphanumeric characters and underscores'
      ),
    target: number()
      .required('Action Target is required')
      .min(1, 'Action Target must be a positive number')
  })
});
